import landingPageModule from "../landingPageModule.js";

function signup() {
    return {
        restrict: "A",
        replace: false,
        templateUrl: "signup",
        controller: "signupController",
        scope: {
            showGenderIcons: "=",
            isFtuxAvatar: "="
        }
    }
}

landingPageModule.directive("signup", signup);

export default signup;
